module.exports = __webpack_public_path__ + "667f09417dac7eedb0da9416bda83735.glb";